import { Text } from '@agro-club/agroclub-shared'
import { refetchFunc } from 'modules/domain/common/hooks'
import { ProfileType, User } from 'modules/domain/user/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CompanyInfo } from './CompanyInfo'
import { Column, WrapperData } from './styled'
import { UserInfo } from './UserInfo'
import { UserResponsibleCoordinator } from './UserTrader/UserResponsibleCoordinator'
import { VerifyStatusList } from './VerifyStatusList/VerifyStatusList'
import { ParentCompanyBlock } from './ParentCompanyBlock'

type Props = {
  userRefetch: refetchFunc
  user: User
  bidsRefetch: () => void
  taskRefetch: refetchFunc
}

export const UserData: FC<Props> = ({ user, userRefetch, bidsRefetch, taskRefetch }) => {
  const { t } = useTranslation(['user'])

  const isCarrier = user.profile?.profile_type === ProfileType.carrier

  const percent = user.profile?.recommended_margin_percent

  const refetchAll = async () => {
    await userRefetch()
    bidsRefetch()
    taskRefetch()
  }
  return (
    <WrapperData>
      <Column>
        <Text color="secondary">{t('user:feature')}</Text>
        <VerifyStatusList user={user} userDataRefetch={refetchAll} />
      </Column>
      <Column>
        <Text color="secondary">{t('company:commonInfo')}</Text>
        <UserInfo user={user} />
      </Column>
      {user.profile?.company && (
        <>
          <Column>
            <Text color="secondary">{t('common:company')}</Text>
            <CompanyInfo company={user.profile.company} />
          </Column>
          <Column>
            <ParentCompanyBlock
              companyId={parseInt(user.profile.company.id)}
              parentId={user.profile.company.parent?.id ? parseInt(user.profile.company.parent.id) : undefined}
              refetch={userRefetch}
            />
          </Column>
        </>
      )}

      <UserResponsibleCoordinator user={user} refetch={userRefetch} />
      {!isCarrier && (
        <Column>
          <Text color="secondary">{t('recommendations')}</Text>
          <div>{t('form.fields.margin', { percent: percent || 0 })}</div>
        </Column>
      )}
    </WrapperData>
  )
}
